import React from 'react';
import { ARCHETYPES } from '../../data/archetypes';
import type { ArchetypeResult } from '../../types/assessment';
type ProfileBarsProps = {
  profile: ArchetypeResult[];
};

/**
 * All eight archetypes, highest to lowest. `profilePct` is the normalized
 * share of the profile (the eight values total 100). See utils/scoring.ts.
 */
export function ProfileBars({
  profile
}: ProfileBarsProps) {
  const max = profile[0]?.profilePct || 1;
  return <ul className="print-block space-y-3.5" data-id="element-48" data-mp="2p7rovdd6gjrq">
      {profile.map((entry, index) => {
      const archetype = ARCHETYPES[entry.key];
      const isPrimary = index === 0;
      return <li key={entry.key} className="grid grid-cols-[8.5rem_1fr_3rem] items-center gap-3 sm:grid-cols-[11rem_1fr_3.5rem] sm:gap-4" data-id="element-49" data-mp="2yymcom62nrfa" data-mpi={index}>
            <div className={`flex items-center gap-2 text-sm ${isPrimary ? 'font-medium text-ink' : 'text-ink-light'}`} data-id="element-50" data-mp="26h0hghcr33fz">
              <span aria-hidden="true" className="text-base" data-id="element-51" data-mp="21g33yi2oqxkt">
                {archetype.emoji}
              </span>
              <span className="truncate" data-id="element-52" data-mp="1up5ozswkk733">{archetype.name}</span>
            </div>

            <div className="h-2 overflow-hidden rounded-full bg-border/70" data-id="element-53" data-mp="1umt0sy07x0hl">
              <div className={`h-full rounded-full transition-[width] duration-300 ease-out ${isPrimary ? 'bg-teal' : 'bg-harbor-light'}`} style={{
            width: `${Math.max(3, entry.profilePct / max * 100)}%`
          }} data-id="element-54" data-mp="1zgdz6r5q3whb" />
            </div>

            <span className={`text-right text-sm tabular-nums ${isPrimary ? 'font-medium text-ink' : 'text-ink-light'}`} data-id="element-55" data-mp="1bse093y9czrn">
              {entry.profilePct}%
            </span>
          </li>;
    })}
    </ul>;
}